export default "__VITE_ASSET___SYz6q68__"